import lifecycleStrings from './translationsLifecycle';

const baseTranslations = {
    en: {
        // Header
        home: "Home",
        build: "Build",
        downloads: "Downloads",
        flavorsAdmin: "Flavors",
        companyName: "Teknologi Kartu Indonesia",
        appBuilder: "App Builder",
        toggleLanguage: "Switch language",
        loginKicker: "Internal release workspace",
        loginTitle: "Sign in to build Android releases.",
        loginDescription: "Use your workspace credentials to access build configuration, live output, and release artifacts.",
        loginFormTitle: "Workspace sign in",
        username: "Username",
        usernamePlaceholder: "Enter your username",
        loginPassword: "Password",
        passwordPlaceholder: "Enter your password",
        showPassword: "Show password",
        hidePassword: "Hide password",
        loginSecureNote: "Credentials will be handled by the workspace endpoint.",
        loginEndpointPending: "Login endpoint is not connected yet.",
        loggingIn: "Signing in…",
        loginFailed: "Login failed. Check username and password.",
        sessionExpired: "Your session has ended. Sign in again to continue.",
        noAccessTitle: "This account has no App Builder access",
        noAccessBody: "Your CRM login works, but its role is not set up for App Builder. Ask an admin to assign sales, designer, developer, or admin.",
        accessCheckFailed: "Could not check your access. Try again in a moment.",
        noBuildAccess: "Your role cannot run builds or read build output.",
        buildAlreadyRunning: "Another build is already running. Wait for it to finish, or follow it.",
        openRunningBuild: "Open running build",
        buildBlockedBySync: "The repository is being updated. Start the build after the update finishes.",
        syncBlockedByBuild: "A build is running. Update the repository after it finishes.",
        backToApplication: "Back to application",
        loginFooter: "Manual sign-in",
        heroTitle: "Build Android releases.",
        heroWordFirst: "Build",
        heroWordAccent: "Android",
        heroWordLast: "releases.",
        heroTagline: "From browser to artifacts.",
        heroDescription: "Choose an existing application flavor, review its release defaults, then run a signed APK and AAB build with live output.",
        newBuild: "New build",
        chooseApplication: "Choose an application",
        loadingFlavors: "Loading applications…",
        openBuilder: "Open builder",
        continueToBuild: "Continue to build",
        buildStartsLater: "No build starts until you confirm in the workspace.",
        noFlavorsAvailable: "No application flavors are available.",
        tryAgain: "Try again",
        latestArtifacts: "Release catalog",
        downloadsTitle: "Latest builds, ready to download.",
        loadingArtifacts: "Loading build artifacts…",
        noMatchingFlavor: "No flavor matches this search.",
        olderBuilds: "Older builds",
        footerNote: "Teknologi Kartu Indonesia",
        
        // Footer
        about: "About",
        aboutText: "Teknologi Kartu Indonesia provides innovative solutions for schools, universities, and businesses. Build custom mobile applications with our powerful platform.",
        quickLinks: "Quick Links",
        contact: "Contact",
        contactText: "Need help? Contact our support team for assistance with your app development needs.",
        rights: "Teknologi Kartu Indonesia. All rights reserved.",
        
        // HomePage
        priceCalculator: "Price Calculator",
        priceCalculatorSub: "Calculate the cost of implementing your digital solution",
        enterPassword: "Enter Password",
        login: "Login",
        logout: "Logout",
        platformSekolahPintar: "Platform Sekolah Pintar",
        closepay: "Closepay",
        summary: "Summary",
        noItemsSelected: "No items selected",
        total: "Total:",
        numberOfStudents: "Number of Students:",
        tierBasedOnStudents: "Price based on number of students (tiering)",
        perMonth: "/month",
        monthly: "Monthly, Tiering",
        perYear: "Per-Year",
        perUser: "Per-User",
        perCard: "Per-Card",
        perDevice: "Per-Device",
        items: "items",
        
        // BuildPage
        buildLogs: "Build logs",
        buildLogsSub: "Configure a flavor, start a build, and inspect its output.",
        buildWorkspace: "Build workspace",
        configuration: "Configuration",
        releaseSetup: "Release setup",
        openExistingSession: "Open existing session",
        invalidFlavorQuery: "Requested flavor was not found. Choose an available flavor.",
        noFlavorQuery: "No flavor selected from the landing page. Choose one here.",
        findFlavorForBuild: "Choose application or flavor",
        liveOutput: "Live output",
        buildStream: "Build stream",
        running: "Running",
        idle: "No active run",
        applicationName: "Application name",
        versionCode: "Version code",
        versionName: "Version name",
        startBuild: "Start build",
        sessionId: "Session ID:",
        enterSessionId: "Enter session ID",
        viewLog: "View log",
        resetLog: "Reset log",
        selectFlavorFirst: "Please select a flavor first!",
        sendingData: "Sending data...",
        dataSentSuccessfully: "Data sent successfully!",
        failedToSendData: "Failed to send data.",
        errorSendingData: "Error occurred while sending data.",
        buildComplete: "Build process complete.",
        systemError: "System Error occurred.",
        backendUnavailable: "Cannot reach backend service right now.",
        requestConflict: "Data changed while processing. Reload and try again.",
        serverError: "Backend returned an internal error.",
        loadFlavorsFailed: "Failed to load flavor list.",
        loadLogsFailed: "Failed to load build logs.",
        webSocketError: "Live log connection failed. Try again in a moment.",
        buildSucceeded: "Build completed successfully.",
        buildFailed: "Build failed. Review the final log lines, then try again.",
        viewDownloads: "View build downloads",
        configureStep: "Configure",
        processStep: "Build process",
        resultStep: "Result",
        repositorySync: "Repository sync",
        updateAssets: "Update assets",
        updatingAssets: "Updating assets…",
        updateAssetsDescription: "Pull the latest Android project assets before starting a build.",
        syncRequired: "Sync required",
        syncBeforeBuild: "Sync before build",
        syncQueued: "Queued",
        syncRunning: "Updating",
        syncSuccess: "Up to date",
        syncFailed: "Update failed",
        syncSuccessDetail: "Repository {action} successfully.",
        syncStartFailed: "Could not start repository update.",
        syncStatusFailed: "Could not read repository update status.",
        syncLogsLabel: "Repository update log",
        
        // DownloadsPage
        downloadsSub: "Find generated APK and AAB files by flavor and date.",
        searchFlavor: "Search flavor",
        findFlavorName: "Find flavor Name...",
        sortBy: "Sort by",
        nameAscending: "Name ascending",
        nameDescending: "Name descending",
        newestFirst: "Newest first",
        oldestFirst: "Oldest first",
        reset: "Reset",
        foundBuilds: "Found {count} build{s}",
        noBuildsFound: "No builds found",
        noBuildsFoundTitle: "No builds found",
        tryAdjustingSearch: "Try adjusting your search or filters",
        clearAllFilters: "Clear all filters",
        download: "Download",
        loadDownloadsFailed: "Failed to load download list.",
        backendHelp: "Check backend status and try again.",
        downloadFilters: "Download filters",
        artifactType: "Artifact type",
        allTypes: "All types",
        dateFrom: "From date",
        dateTo: "To date",
        clearFilters: "Clear filters",
        invalidDateRange: "The end date must be the same as or later than the start date.",
        flavorResults: "{count} flavors",
        artifactCount: "{count} artifacts",
        buildHistory: "{count} older builds",
        noHistory: "No older builds",
        loadingHistory: "Loading build history…",
        downloadingFile: "Downloading…",
        downloadingNamed: "Downloading {file}…",
        buildLogDockLabel: "Running build log",
        openFullLog: "Open full log",
        minimizeBuildLog: "Minimize build log",
        expandBuildLog: "Expand build log",
        closeBuildLog: "Close build log",
        preparingDownload: "Preparing your download…",
        loadHistoryFailed: "Failed to load build history.",
        notAvailable: "Not available",
        paginationLabel: "Download pages",
        rowsPerPage: "Rows",
        pageOf: "Page {page} of {total}",
        previousPage: "Previous page",
        nextPage: "Next page",

        // FlavorsPage
        flavorsTitle: "Flavor control",
        flavorsSub: "Maintain application metadata and release configuration.",
        refreshData: "Refresh data",
        searchFlavorPlaceholder: "Search flavor or app name...",
        totalFlavors: "{count} flavors loaded",
        createFlavor: "Create flavor",
        createNewFlavor: "New flavor",
        editingFlavor: "Editing flavor",
        duplicateFlavor: "Duplicate",
        deleteFlavor: "Delete",
        loadFailed: "Failed to load flavors.",
        saveFailed: "Failed to save flavor.",
        deleteFailed: "Failed to delete flavor.",
        networkError: "Cannot reach backend service right now.",
        authError: "Your role cannot manage flavors.",
        conflictError: "Data changed in GitHub. Reload latest data first.",
        genericLoadHelp: "Check backend status, admin token, then try again.",
        savedSuccessfully: "Flavor saved successfully!",
        deletedSuccessfully: "Flavor deleted successfully!",
        confirmDeleteFlavor: "Delete this flavor?",
        cancel: "Cancel",
        saveChanges: "Save changes",
        createRecord: "Create record",
        generalInfo: "General info",
        distributionInfo: "Distribution and branding",
        sensitiveInfo: "Sensitive build data",
        companyInfo: "Company binding",
        arrayHint: "Choose one or more banks",
        reveal: "Reveal",
        hide: "Hide",
        activeStatus: "Active status",
        multiCompanies: "Multi companies",
        githubSource: "GitHub source",
        fileVersion: "File version",
        unsavedChanges: "Unsaved changes",
        noFlavorSelected: "Pick a flavor or create a new one.",
        flavorName: "Flavor name",
        date: "Date",
        packageName: "Package Name",
        keystoreName: "Keystore name",
        keyAlias: "Key alias",
        password: "Password",
        defaultCompanyId: "Default company ID",
        defaultCompanyName: "Default company name",
        allCompanyName: "All company name",
        urlPlayStore: "Play Store URL",
        primaryColor: "Primary color",
        secondaryColor: "Secondary color",
        banks: "Banks",
        serverKey: "Server key",
        
        // Common
        students: "students"
    },
    id: {
        // Header
        home: "Beranda",
        build: "Bangun",
        downloads: "Unduhan",
        flavorsAdmin: "Flavor",
        companyName: "Teknologi Kartu Indonesia",
        appBuilder: "Pembangun aplikasi",
        toggleLanguage: "Ganti bahasa",
        loginKicker: "Workspace rilis internal",
        loginTitle: "Masuk untuk build Android.",
        loginDescription: "Gunakan credential workspace untuk mengakses konfigurasi build, output realtime, dan hasil rilis.",
        loginFormTitle: "Masuk ke workspace",
        username: "Username",
        usernamePlaceholder: "Masukkan username",
        loginPassword: "Password",
        passwordPlaceholder: "Masukkan password",
        showPassword: "Tampilkan password",
        hidePassword: "Sembunyikan password",
        loginSecureNote: "Credential akan diproses oleh endpoint workspace.",
        loginEndpointPending: "Endpoint login belum terhubung.",
        loggingIn: "Sedang masuk…",
        loginFailed: "Login gagal. Periksa username dan password.",
        sessionExpired: "Sesi Anda sudah berakhir. Masuk lagi untuk melanjutkan.",
        noAccessTitle: "Akun ini belum punya akses App Builder",
        noAccessBody: "Login CRM Anda berhasil, tetapi role-nya belum terdaftar di App Builder. Minta admin menetapkan sales, designer, developer, atau admin.",
        accessCheckFailed: "Akses Anda belum bisa diperiksa. Coba lagi sebentar lagi.",
        noBuildAccess: "Role Anda tidak bisa menjalankan build atau membaca output build.",
        buildAlreadyRunning: "Build lain sedang berjalan. Tunggu sampai selesai, atau ikuti prosesnya.",
        openRunningBuild: "Buka build yang berjalan",
        buildBlockedBySync: "Repository sedang diperbarui. Mulai build setelah pembaruan selesai.",
        syncBlockedByBuild: "Ada build yang berjalan. Perbarui repository setelah build selesai.",
        backToApplication: "Kembali ke aplikasi",
        loginFooter: "Login manual",
        heroTitle: "Buat rilis Android.",
        heroWordFirst: "Buat",
        heroWordAccent: "rilis",
        heroWordLast: "Android.",
        heroTagline: "Dari browser ke artefak.",
        heroDescription: "Pilih flavor aplikasi, periksa default rilis, lalu jalankan build APK dan AAB dengan output realtime.",
        newBuild: "Build baru",
        chooseApplication: "Pilih aplikasi",
        loadingFlavors: "Memuat aplikasi…",
        openBuilder: "Buka builder",
        continueToBuild: "Lanjut ke build",
        buildStartsLater: "Build baru berjalan setelah dikonfirmasi di workspace.",
        noFlavorsAvailable: "Flavor aplikasi belum tersedia.",
        tryAgain: "Coba lagi",
        latestArtifacts: "Katalog rilis",
        downloadsTitle: "Build terbaru, siap diunduh.",
        loadingArtifacts: "Memuat artefak build…",
        noMatchingFlavor: "Tidak ada flavor yang cocok.",
        olderBuilds: "Build lama",
        footerNote: "Workspace rilis Android internal",
        
        // Footer
        about: "Tentang",
        aboutText: "Teknologi Kartu Indonesia menyediakan solusi inovatif untuk sekolah, universitas, dan bisnis. Buat aplikasi seluler kustom dengan platform kami yang powerful.",
        quickLinks: "Tautan Cepat",
        contact: "Kontak",
        contactText: "Butuh bantuan? Hubungi tim dukungan kami untuk bantuan dengan kebutuhan pengembangan aplikasi Anda.",
        rights: "Teknologi Kartu Indonesia. Hak cipta dilindungi.",
        
        // HomePage
        priceCalculator: "Kalkulator Harga",
        priceCalculatorSub: "Hitung biaya implementasi solusi digital Anda",
        enterPassword: "Masukkan Password",
        login: "Masuk",
        logout: "Keluar",
        platformSekolahPintar: "Platform Sekolah Pintar",
        closepay: "Closepay",
        summary: "Ringkasan",
        noItemsSelected: "Belum ada item yang dipilih",
        total: "Total:",
        numberOfStudents: "Jumlah Siswa:",
        tierBasedOnStudents: "Harga berdasarkan jumlah siswa (tiering)",
        perMonth: "/bulan",
        monthly: "Bulanan, Tiering",
        perYear: "Per-Tahun",
        perUser: "Per-Pengguna",
        perCard: "Per-Kartu",
        perDevice: "Per-Perangkat",
        items: "item",
        
        // BuildPage
        buildLogs: "Catatan build",
        buildLogsSub: "Atur flavor, mulai build, lalu periksa outputnya.",
        buildWorkspace: "Workspace build",
        configuration: "Konfigurasi",
        releaseSetup: "Pengaturan rilis",
        openExistingSession: "Buka sesi lama",
        invalidFlavorQuery: "Flavor dari URL tidak ditemukan. Pilih flavor yang tersedia.",
        noFlavorQuery: "Belum ada flavor dari landing. Pilih satu di sini.",
        findFlavorForBuild: "Pilih aplikasi atau flavor",
        liveOutput: "Output realtime",
        buildStream: "Alur build",
        running: "Berjalan",
        idle: "Tidak ada proses aktif",
        applicationName: "Nama aplikasi",
        versionCode: "Kode versi",
        versionName: "Nama versi",
        startBuild: "Mulai build",
        sessionId: "ID Sesi:",
        enterSessionId: "Masukkan ID sesi",
        viewLog: "Lihat log",
        resetLog: "Reset log",
        selectFlavorFirst: "Pilih flavor dulu!",
        sendingData: "Mengirim data...",
        dataSentSuccessfully: "Data berhasil dikirim!",
        failedToSendData: "Gagal mengirim data.",
        errorSendingData: "Terjadi error saat mengirim data.",
        buildComplete: "Proses build selesai.",
        systemError: "Terjadi Kesalahan Sistem.",
        backendUnavailable: "Tidak bisa terhubung ke layanan backend saat ini.",
        requestConflict: "Data berubah saat proses berjalan. Muat ulang lalu coba lagi.",
        serverError: "Backend mengembalikan error internal.",
        loadFlavorsFailed: "Gagal memuat daftar flavor.",
        loadLogsFailed: "Gagal memuat log build.",
        webSocketError: "Koneksi log realtime gagal. Coba lagi sebentar.",
        buildSucceeded: "Build berhasil diselesaikan.",
        buildFailed: "Build gagal. Periksa baris terakhir log, lalu coba lagi.",
        viewDownloads: "Lihat hasil build",
        configureStep: "Konfigurasi",
        processStep: "Proses build",
        resultStep: "Hasil",
        repositorySync: "Sinkronisasi repository",
        updateAssets: "Perbarui assets",
        updatingAssets: "Memperbarui assets…",
        updateAssetsDescription: "Tarik assets project Android terbaru sebelum memulai build.",
        syncRequired: "Wajib sync",
        syncBeforeBuild: "Sync sebelum build",
        syncQueued: "Dalam antrean",
        syncRunning: "Sedang update",
        syncSuccess: "Sudah terbaru",
        syncFailed: "Update gagal",
        syncSuccessDetail: "Repository berhasil {action}.",
        syncStartFailed: "Gagal memulai update repository.",
        syncStatusFailed: "Gagal membaca status update repository.",
        syncLogsLabel: "Log update repository",
        
        // DownloadsPage
        downloadsSub: "Cari file APK dan AAB berdasarkan flavor dan tanggal.",
        searchFlavor: "Cari flavor",
        findFlavorName: "Cari nama Flavor...",
        sortBy: "Urutkan Berdasarkan",
        nameAscending: "Nama Menaik",
        nameDescending: "Nama Menurun",
        newestFirst: "Terbaru Dahulu",
        oldestFirst: "Terlama Dahulu",
        reset: "Reset",
        foundBuilds: "Ditemukan {count} build",
        noBuildsFound: "Tidak ada build yang ditemukan",
        noBuildsFoundTitle: "Tidak ada build yang ditemukan",
        tryAdjustingSearch: "Coba sesuaikan pencarian atau filter Anda",
        clearAllFilters: "Hapus Semua Filter",
        download: "Unduh",
        loadDownloadsFailed: "Gagal memuat daftar unduhan.",
        backendHelp: "Cek status backend lalu coba lagi.",
        downloadFilters: "Filter unduhan",
        artifactType: "Tipe artefak",
        allTypes: "Semua tipe",
        dateFrom: "Tanggal mulai",
        dateTo: "Tanggal akhir",
        clearFilters: "Hapus filter",
        invalidDateRange: "Tanggal akhir harus sama atau setelah tanggal mulai.",
        flavorResults: "{count} flavor",
        artifactCount: "{count} artefak",
        buildHistory: "{count} build lama",
        noHistory: "Tidak ada build lama",
        loadingHistory: "Memuat riwayat build…",
        downloadingFile: "Mengunduh…",
        downloadingNamed: "Mengunduh {file}…",
        buildLogDockLabel: "Log build berjalan",
        openFullLog: "Buka log penuh",
        minimizeBuildLog: "Kecilkan log build",
        expandBuildLog: "Perbesar log build",
        closeBuildLog: "Tutup log build",
        preparingDownload: "Menyiapkan unduhan…",
        loadHistoryFailed: "Gagal memuat riwayat build.",
        notAvailable: "Belum tersedia",
        paginationLabel: "Halaman unduhan",
        rowsPerPage: "Baris",
        pageOf: "Halaman {page} dari {total}",
        previousPage: "Halaman sebelumnya",
        nextPage: "Halaman berikutnya",

        // FlavorsPage
        flavorsTitle: "Kontrol flavor",
        flavorsSub: "Kelola metadata aplikasi dan konfigurasi rilis.",
        refreshData: "Muat ulang",
        searchFlavorPlaceholder: "Cari flavor atau nama aplikasi...",
        totalFlavors: "{count} flavor dimuat",
        createFlavor: "Buat flavor",
        createNewFlavor: "Flavor baru",
        editingFlavor: "Sedang edit",
        duplicateFlavor: "Duplikat",
        deleteFlavor: "Hapus",
        loadFailed: "Gagal memuat flavor.",
        saveFailed: "Gagal menyimpan flavor.",
        deleteFailed: "Gagal menghapus flavor.",
        networkError: "Tidak bisa terhubung ke layanan backend saat ini.",
        authError: "Role Anda tidak bisa mengelola flavor.",
        conflictError: "Data sudah berubah di GitHub. Muat ulang data terbaru dulu.",
        genericLoadHelp: "Cek status backend, token admin, lalu coba lagi.",
        savedSuccessfully: "Flavor berhasil disimpan!",
        deletedSuccessfully: "Flavor berhasil dihapus!",
        confirmDeleteFlavor: "Hapus flavor ini?",
        cancel: "Batal",
        saveChanges: "Simpan perubahan",
        createRecord: "Buat data",
        generalInfo: "Info umum",
        distributionInfo: "Distribusi dan branding",
        sensitiveInfo: "Data build sensitif",
        companyInfo: "Binding perusahaan",
        arrayHint: "Pilih satu atau lebih bank",
        reveal: "Tampil",
        hide: "Sembunyi",
        activeStatus: "Status aktif",
        multiCompanies: "Multi perusahaan",
        githubSource: "Sumber GitHub",
        fileVersion: "Versi file",
        unsavedChanges: "Perubahan belum disimpan",
        noFlavorSelected: "Pilih flavor atau buat baru.",
        flavorName: "Nama flavor",
        date: "Tanggal",
        packageName: "Nama paket",
        keystoreName: "Nama keystore",
        keyAlias: "Key Alias",
        password: "Password",
        defaultCompanyId: "ID perusahaan default",
        defaultCompanyName: "Nama perusahaan default",
        allCompanyName: "Semua nama perusahaan",
        urlPlayStore: "URL Play Store",
        primaryColor: "Warna primer",
        secondaryColor: "Warna sekunder",
        banks: "Bank",
        serverKey: "Server Key",
        
        // Common
        students: "siswa"
    }
};

export const translations = {
    en: { ...baseTranslations.en, ...lifecycleStrings.en },
    id: { ...baseTranslations.id, ...lifecycleStrings.id },
};
